import { gql } from '@apollo/client';

const queryByline = gql`
query GET_BYLINE(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $byline: String 
  ){
    posts(first: $first,
      		last: $last,
      		before: $before,
      		after: $after,
      		where: {byline: $byline}
    ) {
      edges {
        node {
          databaseId
          title
          bylineInformation {
            byline
            bylineTitle
            bylineWebsite
            bylineAffiliation
            firstTwitterSocialLink
            firstFacebookSocialLink
            firstLinkedinSocialLink
            byline2
            byline2Title
            byline2Website
            byline2Affiliation
            secondTwitterSocialLink
            secondFacebookSocialLink
            secondLinkedinSocialLink
          }
        }
      }
    }
}
`

export default queryByline
